import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import MuiInput from "@mui/material/Input";
import Slider from "@mui/material/Slider";
import { styled } from "@mui/material/styles";
import {
  ComponentRef,
  getComponentRef,
} from "../../message/components/records/MessageTagUtil";

const Input = styled(MuiInput)`
  width: 42px;
`;

export default function TemperatureInput(props) {
  const {
    label,
    id,
    readOnly,
    required,
    onChange,
    minRange,
    maxRange,
    marks: propsMarks,
    defaultSteps,
    onSaveDraft = () => {},
    value,
  } = props;

  const {
    handleSubComponentLoaded = (
      subComponent = { ...ComponentRef },
      isLoaded = false
    ) => {},
  } = props;
  const { itemIndex, level, messageTime } = props;
  const [marks, setMarks] = useState(propsMarks);
  const [internalValue, setInternalValue] = useState(value ?? minRange);

  useEffect(() => {
    if (internalValue) {
      setInternalValue(value);
    }
  }, [value]);

  useEffect(() => {
    handleSubComponentLoaded(
      getComponentRef("TemperatureInput", itemIndex, level, messageTime),
      true
    );

    const actualMarks = props.marks || [];
    if (actualMarks.length === 0) {
      for (let i = minRange; i <= maxRange; i += 10) {
        marks.push({
          value: i,
          label: `${i}°F`,
        });
      }
    } else {
      actualMarks.forEach((mark) => {
        mark.label = `${mark.label}°F`;
      });
    }

    setMarks(actualMarks);
  }, []);

  const handleOnChange = (newValue) => {
    setInternalValue(newValue);
    onChange(id, newValue);
  };

  const handleOnBlur = () => {
    if (internalValue < parseFloat(minRange)) {
      setInternalValue(parseFloat(minRange));
    } else if (internalValue > parseFloat(maxRange)) {
      setInternalValue(parseFloat(maxRange));
    }

    onSaveDraft();
  };

  const renderReadOnly = () => {
    if (!internalValue || internalValue.length === 0) {
      return null;
    }
    return (
      <div>
        <Typography variant="subtitle1" fontWeight="bold">
          {label}:{" "}
        </Typography>
        <Typography>{`${internalValue}°F`}</Typography>
      </div>
    );
  };

  const renderElement = () => {
    if (readOnly) {
      return renderReadOnly();
    }

    return (
      <Box>
        <Typography variant="subtitle2" id={id}>
          {label}
        </Typography>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Slider
            aria-label="Volume"
            value={internalValue}
            onChange={(_, newValue) => {
              handleOnChange(newValue);
            }}
            min={Number(minRange)}
            max={Number(maxRange)}
            step={Number(defaultSteps)}
            valueLabelDisplay="auto"
            marks={marks}
          />
          <Input
            style={{ marginLeft: "20px" }}
            value={internalValue}
            size="small"
            onChange={(e) => {
              handleOnChange(
                e.target.value === "" ? 0 : Number(e.target.value)
              );
            }}
            onClick={(e) => e.stopPropagation()}
            onBlur={handleOnBlur}
            inputProps={{
              step: defaultSteps,
              min: minRange,
              max: maxRange,
              type: "number",
              "aria-labelledby": "input-slider",
            }}
          />
        </Box>
      </Box>
    );
  };

  return renderElement();
}
